function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "#4E4E4E",
  strokeWidth: 1.067,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.179 6.583h8.309a1.067 1.067 0 0 1 1.061 1.173l-.853 8.533c-.054.546-.513.961-1.061.961H3.032a1.067 1.067 0 0 1-1.061-.96l-.854-8.534A1.067 1.067 0 0 1 2.18 6.583zM1.776 3.19l2.973-.744a.683.683 0 0 0 .518-.663c0-.294.238-.533.533-.533h1.067c.294 0 .533.239.533.533 0 .314.213.587.517.663l2.973.743c.457.114.777.524.777.995a.8.8 0 0 1-.8.8H1.8a.8.8 0 0 1-.8-.8c0-.47.32-.88.776-.995z"
}));

function SvgDaxDeleteicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaxDeleteicon);
export default __webpack_public_path__ + "static/media/dax-deleteicon.43f39b27.svg";
export { ForwardRef as ReactComponent };